module.exports = __webpack_public_path__ + "static/framestore-e82a572e0b16853b3e8a7239736907b8.png";